module.exports = __webpack_public_path__ + "img/watermark-white.d31cc170.png";